/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ToggleArrowRightIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "toggle-arrow-right", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9 17V8L17 12.5L9 17Z", fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(ToggleArrowRightIcon);
export default ForwardRef;
//# sourceMappingURL=toggleArrowRightIcon.js.map